var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("auth-layout", { staticClass: "not-found-page" }, [
    _c("div", { staticClass: "centered" }, [
      _c("h1", [
        _c("i", { staticClass: "not-found-icon nc-icon nc-puzzle-10" }),
        _vm._v("404")
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("The page you requested could not be found.")]),
      _vm._v(" "),
      this.$store.getters["account/isLoggedIn"]
        ? _c("a", { attrs: { href: "/#/dashboard" } }, [
            _vm._v("Back To Dashboard.")
          ])
        : _c("a", { attrs: { href: "/#/login" } }, [_vm._v("Back To Login.")])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5745e353", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5745e353","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/GeneralViews/NotFoundPage.vue
// module id = JCiV
// module chunks = 4